
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attributes",
      function () {
        return require("private-next-pages/attributes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attributes"])
      });
    }
  